import {
  FETCHING_ASSET_REQUEST,
  FETCHING_ASSET_SUCCEEDED,
  FETCHING_ASSET_FAILED,
  FETCHING_ASSET_ANALYTICS_REQUEST,
  FETCHING_ASSET_ANALYTICS_SUCCEEDED,
  FETCHING_ASSET_ANALYTICS_FAILED,
  FETCHING_ASSET_SUBTITLE,
  FETCHING_ASSET_SUBTITLE_SUCCEDDED,
  FETCHING_ASSET_SUBTITLE_FAILED,
  UPDATING_SUBTITLE,
  UPDATING_SUBTITLE_SUCCEDDED,
  UPDATING_SUBTITLE_FAILED,
  UPDATING_ASSET_REQUEST,
  UPDATING_ASSET_SUCCEEDED,
  UPDATING_ASSET_FAILED,
  RECORD_SESSION_ANALYTICS_EVENT,
  RECORDING_SESSION_ANALYTICS_EVENT_SUCCEEDED,
  RECORDING_SESSION_ANALYTICS_EVENT_FAILED,
  FETCHING_PREVIEW_ASSET,
  FETCHING_PREVIEW_ASSET_SUCCEEDED,
  FETCHING_PREVIEW_ASSET_FAILED,
  UPDATING_CLEVERSTORY_ASSET_METADATA_SUCCEEDED,
  UPDATE_CLEVERSTORY_ASSET_METADATA_REQUEST,
  UPLOADING_NEW_VERSION_SUCCEEDED,
  UPLOADING_NEW_VERSION_FAILED,
  WS_ASSET_PROCESSED,
  CANCEL_NEW_VERSION_UPLOAD,
  FETCH_ASSET_INSIGHTS,
  FETCHING_ASSET_INSIGHTS_SUCCEEDED,
  FETCHING_ASSET_INSIGHTS_FAILED,
  FETCH_ASSET_PREVIEW_TEXT,
  FETCHING_ASSET_PREVIEW_TEXT_SUCCEEDED,
  FETCHING_ASSET_PREVIEW_TEXT_FAILED,
  CLONE_ASSET_REQUEST,
  CLONING_ASSET_SUCCEDDED,
  CLONING_ASSET_FAILED,
  SELECT_ASSET_PAGE,
  REARRANGE_ASSET_PAGES,
  REMOVE_ASSET_PAGE,
  INVALIDATE_SELECTED_ASSET_PAGES,
  CREATING_ASSET_FROM_HUB,
  CREATING_ASSET_FROM_HUB_SUCCEEDED,
  CREATING_ASSET_FROM_HUB_FAILED,
  MODIFY_PAGES_IN_ASSET,
  MODIFYING_PAGES_IN_ASSET_SUCCEEDED,
  MODIFYING_PAGES_IN_ASSET_FAILED,
  INVALIDATE_ASSET_UPDATE,
  TRIGGER_ASSET_PROCESSING_REQUEST,
  TRIGGER_ASSET_PROCESSING_SUCCEEDED,
  TRIGGER_ASSET_PROCESSING_FAILED,
  INVALIDATE_ADD_ASSET_COLLECTIONS,
  INVALIDATE_ASSET_CLONE,
  INVALIDATE_SUBTITLE_UPDATE,
  FETCH_RECOMMENDED_ASSETS,
  FETCHING_RECOMMENDED_ASSETS_SUCCEDDED,
  FETCHING_RECOMMENDED_ASSETS_FAILED,
  FETCHING_PREVIEW_HTML_TEMPLATE,
  FETCHING_PREVIEW_HTML_TEMPLATE_SUCCEDDED,
  FETCHING_PREVIEW_HTML_TEMPLATE_FAILED,
  WS_ASSET_MERGE_STATUS,
  UPLOAD_FILE_REQUEST,
  UPLOADING_FILE_PROGRESS,
  UPLOADING_FILE_FAILED,
  UPLOADING_FILE_SUCCEDDED,
  CREATE_ASSET_FROM_FILE_REQUEST,
  CREATING_ASSET_FROM_FILE_SUCCEDDED,
  INVALIDATE_ASSET_UPLOAD,
  CREATE_LINK_ASSET_REQUEST,
  CREATING_LINK_ASSET_SUCCEEDED,
  INVALIDATE_LINK_ASSET,
  FETCH_ASSET_PROMPTS,
  FETCHING_ASSET_PROMPTS_SUCCEEDED,
  FETCHING_ASSET_PROMPTS_FAILED,
  INITIATE_UPLOAD_NEW_VERSION,
  ADD_ASSETS_TO_COLLECTION_ON_SERVER,
  ADDING_ASSETS_TO_COLLECTION_ON_SERVER_SUCCEDDED,
  ADDING_ASSETS_TO_COLLECTION_ON_SERVER_FAILED,
  ADD_ASSETS_TO_SECTION_ON_SERVER,
  ADD_ASSETS_TO_SECTION_ON_SERVER_SUCCEDDED,
  ADD_ASSETS_TO_SECTION_ON_SERVER_FAILED,
  CREATING_LINK_ASSET_FAILED,
  INVALIDATE_ASSET_RECOMMENDATIONS,
  FETCHING_ASSET_STORAGE_LIMIT,
  FETCHING_ASSET_STORAGE_LIMIT_SUCCEEDED,
  FETCHING_ASSET_STORAGE_LIMIT_FAILED,
  CREATING_ASSET_FROM_FILE_FAILED,
  FETCHING_CONTENT_RECOMMENDATIONS_REQUEST,
  FETCHING_CONTENT_RECOMMENDATIONS_SUCCEDDED,
  FETCHING_CONTENT_RECOMMENDATIONS_FAILED,
  ADD_ASSET_TO_CONTENT_SIMILARITY_QUEUE,
  TOGGLE_ASSET_STATUS_IN_CONTENT_SIMILARITY_QUEUE,
  FETCH_DUPLICATE_ASSET,
  FETCHING_DUPLICATE_ASSET_SUCCEDDED,
  INVALIDATE_SIMILAR_ASSET,
  INVALIDATE_ASSET,
  FETCH_TABLE_OF_CONTENTS,
  FETCHING_TABLE_OF_CONTENTS_SUCCEEDED,
  FETCHING_TABLE_OF_CONTENTS_FAILED,
  UPDATE_TABLE_OF_CONTENTS,
  UPDATING_TABLE_OF_CONTENTS_SUCCEEDED,
  UPDATING_TABLE_OF_CONTENTS_FAILED,
  DELETE_TABLE_OF_CONTENTS,
  DELETING_TABLE_OF_CONTENTS_SUCCEEDED,
  DELETING_TABLE_OF_CONTENTS_FAILED,
  INVALIDATE_UPDATE_TABLE_OF_CONTENTS,
  INVALIDATE_TABLE_OF_CONTENTS,
  CAPTURED_ASSET_VIDEO_NEW_RANGE,
  UPDATED_ASSET_VIDEO_RANGE,
  REMOVED_ASSET_VIDEO_RANGE,
  SYNCING_ASSET_VIEW_RANGE_REQUEST,
  SYNCING_ASSET_VIEW_RANGE_SUCCEDDED,
  SYNCING_ASSET_VIEW_RANGE_FAILED
} from "../actions/actionTypes";
import {
  Asset,
  FetchAssetAnalyticsResponse,
  FetchAssetResponse,
  FetchAssetSubtitleResponse,
  UpdateSubtitleResponse,
  FetchPreviewAssetErrorResponse,
  RecordSessionAnalyticsEventResponse,
  UpdateAssetErrorResponse,
  UpdateAssetRequest,
  UpdateAssetResponse,
  UploadNewVersionResponse,
  UploadNewVersionErrorResponse,
  FetchPreviewAsset,
  AssetPreview,
  CloningAssetErrorResponse,
  TriggerAssetProcessingResponse,
  TriggerAssetProcessingErrorResponse,
  InvalidateAssetUpdate,
  FetchAssetSubtitleRequest,
  FetchAssetSubtitleErrorResponse,
  FetchRecommendedAssetsResponse,
  UploadAssetRequest,
  UploadAssetProgressRequest,
  UploadAssetResponse,
  AssetUpload,
  CreateLinkAssetResponse,
  InitiateUploadNewVersionRequest,
  CreateLinkAssetRequest,
  CreateLinkAssetErrorResponse,
  FetchAssetStorageLimitResponse,
  FetchAssetStorageLimitFailed,
  Section,
  FetchAssetTableOfContentsResponse,
  FetchAssetTableOfContentsErrorResponse,
  updateTableOfContentsRequest,
  updateTableOfContentsResponse,
  updateTableOfContentsErrorResponse,
  UpdateVideoRangeRequest,
  SyncAssetVideoRangeRequest,
  SyncAssetVideoRangeResponse,
  SyncAssetVideoRangeErrorResponse
} from "../../types/assets";
import { UnknownAction } from "redux-saga";

import _ from "lodash";
import { IPage } from "src/types/assets";
import { AddAssetToCollectionErrorResponse, AddAssetToCollectionRequest, AddAssetToCollectionResponse } from "src/types/collections";
import { ErrorCodes } from "src/services/error.service";

interface AssetState {
  loading: boolean;
  item: any | null;
  analytics: AssetAnalyticsState;
  errors: any | null;
  update: {
    [key: string]: AssetUpdateState;
  };
  upload: {
    [key: string]: UploadState;
  };
  session: SessionState;
  preview: PreviewState;
  uploadVersion: NewVersionUploadState;
  process: ProcessState;
  insights: InsightsState;
  subtitle: SubtitleState;
  clone: CloneState;
  assetsPreview: AssetsPreviewState,
  selectedPages: IPage[],
  createAsset: CreateAssetState,
  collections: AddCollectionState
  merge: {
    initiated?: boolean,
    merged?: boolean,
    status?: string,
    merging?: boolean,
    error?: boolean
  },
  preparing: boolean,
  recommended: RecommendedState;
  linkAsset: {
    [key: string]: LinkAssetState
  },
  storageLimit : {
    isLimitReached?: boolean
    fetching: boolean,
    error?: null,
    result? : any | null
    paperfliteAssets?: paperfliteAssetState,
    contentSource?:contentSourceState
  },
  recommendedAssets : RecommendedAssetsState,
  similarity: SimilarityState,
  tableOfContents: TableOfContentsState
}
interface paperfliteAssetState {
  assetStorageUsed: number,
  assetStorageLimit: number
}
interface contentSourceState {
  datasourceFilesUsed: number,
  datasourceFilesLimit: number
}
interface LinkAssetState {
  id: string;
  url: string;
  item: Asset | null,
  creating: boolean,
  created: boolean,
  error?: any;
}
interface AddCollectionState {
  [key: string]: {
    id: string;
    adding: boolean;
    added: boolean;
    errors: any;
  }
}

interface CloneState {
  cloning: boolean;
  cloned: boolean;
  item: Asset | null;
  error: any | null;
}

interface RecommendedState {
  loading: boolean;
  items: Asset[] | null;
  error: any;
}

interface CreateAssetState {
  loading: boolean,
  succeeded: boolean,
  error: any,
  item?: Asset | null
}

interface AssetsPreviewState {
  [key: string]: {
    loading: boolean,
    succeeded: boolean,
    item: AssetPreview | null
    error: any
  }
}

interface RecommendedAssetsState {
  loading : boolean,
  items : Asset[] | null,
  error : any,
  fetched : boolean;
}

const initialcloneState: CloneState = {
  cloning: false,
  cloned: false,
  item: null,
  error: null,
};

const initialRecommendedState: RecommendedState = {
  loading: false,
  items: null,
  error: null
}

const initialRecommendedAssetsState : RecommendedAssetsState = {
  loading : false,
  items : null,
  error : null,
  fetched : false
}

interface SimilarityState {
  processing: boolean;
  processed: boolean;
  item: any | null;
  initialise: boolean;
  similarAsset: any;
}

interface TableOfContentsState {
  id: string,
  loading: boolean;
  sections : Section[];
  succeeded: boolean;
  error: any | null;
  delete:{
    loading: boolean;
    succeeded: boolean;
    error: any | null;
  },
  update:{
    loading: boolean;
    succeeded: boolean;
    error: any | null;
  },
  version: number;
  modifiedDate: Date | null;
}

const initialSimilarityState: SimilarityState = {
  processing: false,
  processed: false,
  item: null,
  initialise: false,
  similarAsset: null
}
interface InsightsState {
  loading: boolean;
  item: any | null;
  errors: any | null;
}

interface SubtitleState {
  items: any | null;
  updating: boolean;
  updated: boolean;
  error: any | null;
}

interface PreviewState {
  loading: boolean;
  item: any | null;
  error: any | null;
  succeeded: boolean;
  htmlPreview?: string;
}

interface SessionState {
  id: string | null;
  creating: boolean;
  updating: boolean;
  preparing: boolean;
  fetching: boolean;
  page: {
    index: 0;
    creating: boolean;
    updating: boolean;
  };
  ranges: any[];
}

const initialInsightsState = {
  loading: false,
  item: null,
  errors: null,
};

const initialVersionUploadState: NewVersionUploadState = {
  id: "",
  file: "",
  uploading: false,
  uploaded: false,
  creating: false,
  created: false,
  source: null,
  error: null
};

const initialUploadState: UploadState = {
  uploading: false,
  uploaded: false,
  creating: false,
  created: false,
  source: null,
  item: null,
  error: null,
};

const initialProcessState: ProcessState = {
  processing: false,
  processingCreatedDate: null,
  error: null
}

const initialPreviewState: PreviewState = {
  loading: false,
  item: null,
  error: null,
  succeeded: false
};

const initialSubtitleState: SubtitleState = {
  items: null,
  updating: false,
  updated: false,
  error: null
}

const initialSessionState: SessionState = {
  id: null,
  creating: false,
  updating: false,
  preparing: false,
  fetching: false,
  page: {
    index: 0,
    creating: false,
    updating: false,
  },
  ranges: [],
};

const initialTableOfContentsState : TableOfContentsState =  {
  id: "",
  loading: false,
  sections: [],
  succeeded: false,
  error: null,
  delete: {
    loading: false,
    succeeded: false,
    error: null,
  },
  update: {
    loading: false,
    succeeded: false,
    error: null,
  },
  version: -1,
  modifiedDate: null
}


const initialState: AssetState = {
  loading: false,
  item: null,
  analytics: {
    loading: false,
    item: null,
    errors: null,
  },
  errors: null,
  update: {},
  upload: {},
  session: {
    ...initialSessionState,
  },
  preview: {
    ...initialPreviewState
  },
  uploadVersion: {
    ...initialVersionUploadState
  },
  process: {
    ...initialProcessState
  },
  insights: {
    ...initialInsightsState
  },
  subtitle: {
    ...initialSubtitleState,
  },
  clone: initialcloneState,
  recommended: initialRecommendedState,
  assetsPreview: {},
  selectedPages: [],
  createAsset: {
    loading: false,
    succeeded: false,
    error: null,
    item: null
  },
  collections: {},
  merge: {},
  preparing: false,
  linkAsset: {},
  recommendedAssets : initialRecommendedAssetsState,
  storageLimit:{
      fetching: false,
      error: null,
      result :  null,
      paperfliteAssets: {
        assetStorageUsed: 0,
        assetStorageLimit: 0
      },
      contentSource:{
        datasourceFilesUsed: 0,
        datasourceFilesLimit: 0
      }
  },
  similarity: initialSimilarityState,
  tableOfContents: initialTableOfContentsState
  
};
interface UploadState {
  id?: string;
  uploading: boolean;
  uploaded: boolean;
  creating: boolean;
  created: boolean;
  source: any | null;
  item: Asset | AssetUpload | null;
  error: any;
}

interface NewVersionUploadState {
  id: string;
  file: string;
  uploading: boolean;
  uploaded: boolean;
  creating: boolean;
  created: boolean;
  source: any | null;
  error: any;
}

interface ProcessState {
  processing: boolean,
  processingCreatedDate: Date | null,
  error: any
}
interface AssetUpdateState {
  id: string;
  updating: boolean;
  updated: boolean;
  item: Asset | null;
  error: any | null;
}
interface AssetAnalyticsState {
  loading: boolean;
  item: any | null;
  errors?: any | null;
}

const initialUpdateAssetRequest = {
  id: "",
  updating: false,
  updated: false,
  item: null,
  error: null,
};

type Action = UnknownAction;

export function assetsReducer(
  state: AssetState = initialState,
  action: Action,
): AssetState {
  switch (action.type) {
    case FETCHING_ASSET_REQUEST: {
      return {
        ...state,
        loading: true,
        errors: null,
        item:{
          ...state.item,
          loading: true
        }
      };
    }

    case FETCHING_ASSET_SUCCEEDED: {
      const data = action.payload as FetchAssetResponse;
      return {
        ...state,
        loading: false,
        item: {
          ...state.item,
          ...data,
          loading: false
        },
        errors: null,
      };
    }

    case FETCHING_ASSET_FAILED: {
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    }

    case FETCHING_ASSET_SUBTITLE: {
      const { id } = action.payload as FetchAssetSubtitleRequest;
      return {
        ...state,
        subtitle: {
          ...state.subtitle,
          items: null,
          updating: false,
          updated: false,
          error: null,
        },
      };
    }

    case FETCHING_ASSET_SUBTITLE_SUCCEDDED: {
      const { response } = action.payload as FetchAssetSubtitleResponse;
      return {
        ...state,
        subtitle: {
          ...state.subtitle,
          items: response,
          updating: false,
          updated: false,
          error: null,
        },
      };
    }

    case FETCHING_ASSET_SUBTITLE_FAILED: {
      const { error } = action.payload as FetchAssetSubtitleErrorResponse;
      return {
        ...state,
        subtitle: {
          ...state.subtitle,
          updating: false,
          updated: false,
          error: error,
        },
      };
    }

    case UPDATING_SUBTITLE: {
      return {
        ...state,
        subtitle: {
          ...state.subtitle,
          updating: true,
          updated: false,
          error: null,
        },
      };
    }

    case UPDATING_SUBTITLE_SUCCEDDED: {
      const { subtitle, response } = action.payload as UpdateSubtitleResponse;
      return {
        ...state,
        subtitle: {
          ...state.subtitle,
          items: subtitle,
          updating: false,
          updated: true,
          error: null,
        },
        item: response,
      };
    }

    case UPDATING_SUBTITLE_FAILED: {
      const error = action.payload;
      return {
        ...state,
        subtitle: {
          ...state.subtitle,
          updating: false,
          updated: false,
          error: error,
        },
      };
    }

    case INVALIDATE_SUBTITLE_UPDATE: {
      return {
        ...state,
        subtitle: {
          ...state.subtitle,
          updating: false,
          updated: false,
          error: null,
        },
      };
    }

    case FETCHING_ASSET_ANALYTICS_REQUEST: {
      return {
        ...state,
        analytics: {
          ...state.analytics,
          loading: true,
          item: null, //has to be checked
        },
      };
    }

    case FETCHING_ASSET_ANALYTICS_SUCCEEDED: {
      const data = action.payload as FetchAssetAnalyticsResponse;
      return {
        ...state,
        analytics: {
          ...state.analytics,
          loading: false,
          [data.assetId]: data.response,
          item: data.response,
        },
      };
    }

    case FETCHING_ASSET_ANALYTICS_FAILED: {
      const error = action.payload;
      return {
        ...state,
        analytics: {
          //has to be checked
          ...state.analytics,
          loading: false,
          errors: error,
        },
      };
    }

    case UPDATING_ASSET_REQUEST:
    case UPDATE_CLEVERSTORY_ASSET_METADATA_REQUEST: {
      const { id } = action.payload as UpdateAssetRequest;
      const updateState = state.update[id] || initialUpdateAssetRequest;

      return {
        ...state,
        update: {
          ...state.update,
          [id]: {
            ...updateState,
            id,
            updating: true,
            updated: false,
            item: null,
            error: null,
          },
        },
      };
    }

    case UPDATING_ASSET_SUCCEEDED:
    case UPDATING_CLEVERSTORY_ASSET_METADATA_SUCCEEDED: {
      const { response } = action.payload as UpdateAssetResponse;
      const id = response.id;

      if (!id) {
        return state;
      }

      const updateState = state.update[id];
      if (!updateState) {
        return state;
      }

      return {
        ...state,
        item: response,
        update: {
          ...state.update,
          [id]: {
            ...updateState,
            id,
            updating: false,
            updated: true,
            item: response,
            error: null,
          },
        },
      };
    }

    case UPDATING_ASSET_FAILED: {
      const { id, error } = action.payload as UpdateAssetErrorResponse;

      const updateState = state.update[id];
      if (!updateState) {
        return state;
      }

      return {
        ...state,
        update: {
          ...state.update,
          [id]: {
            ...updateState,
            id,
            updating: false,
            updated: false,
            error: error,
          },
        },
      };
    }

    case RECORD_SESSION_ANALYTICS_EVENT: {
      return {
        ...state,
        session: {
          ...initialSessionState,
          creating: true
        },
      };
    }

    case RECORDING_SESSION_ANALYTICS_EVENT_SUCCEEDED: {
      const { id } = action.payload as RecordSessionAnalyticsEventResponse;
      return {
        ...state,
        session: {
          ...state.session,
          id: id,
          creating: false,
        },
      };
    }

    case RECORDING_SESSION_ANALYTICS_EVENT_FAILED: {
      return {
        ...state,
        session: {
          ...state.session,
          creating: false,
        },
      };
    }

    case FETCHING_PREVIEW_ASSET: {
      const { id } = action.payload as FetchPreviewAsset;
      return {
        ...state,
        preview: {
          ...state.preview,
          loading: true,
          succeeded: false,
        },
        assetsPreview: {
          ...state.assetsPreview,
          [id]: {
            loading: true,
            succeeded: false,
            item: null,
            error: null,
          },
        },
      };
    }

    case FETCHING_PREVIEW_ASSET_SUCCEEDED: {
      const { id, response } = action.payload as any;

      return {
        ...state,
        preview: {
          ...state.preview,
          loading: false,
          item: response,
          succeeded: true,
        },
        assetsPreview: {
          ...state.assetsPreview,
          [id]: {
            loading: false,
            succeeded: true,
            item: response,
            error: null,
          },
        },
      };
    }

    case FETCHING_PREVIEW_ASSET_FAILED: {
      const { id, error } = action.payload as FetchPreviewAssetErrorResponse;

      return {
        ...state,
        preview: {
          ...state.preview,
          loading: false,
          error: error,
          succeeded: false,
        },
        assetsPreview: {
          ...state.assetsPreview,
          [id]: {
            loading: false,
            succeeded: false,
            item: null,
            error: error,
          },
        },
      };
    }

    case FETCHING_ASSET_PREVIEW_TEXT_SUCCEEDED: {
      const response = action.payload as any;

      return {
        ...state,
        assetsPreview: {
          ...state.assetsPreview,
          [response.asset]: {
            ...state.assetsPreview[response.asset],
            pagesWithTexts: response,
          },
        },
      };
    }

    case FETCH_ASSET_PREVIEW_TEXT:
      return {
        ...state,
        preview: {
          ...state.preview,
          item: {
            ...state.preview.item,
            loading: true,
          },
        },
      };

    case FETCHING_ASSET_PREVIEW_TEXT_FAILED:
      return {
        ...state,
        preview: {
          ...state.preview,
          error: action.payload,
          item: {
            ...state.preview.item,
            loading: false,
          },
        },
      };

    case INITIATE_UPLOAD_NEW_VERSION: {
      const { id, file } = action.payload as InitiateUploadNewVersionRequest;
      return {
        ...state,
        uploadVersion: {
          ...initialVersionUploadState,
          id: id,
          file: file,
          uploading: true,
          uploaded: false,
          source: null,
        },
        storageLimit : {
          ...state.storageLimit,
          isLimitReached: false
        }
      }
    }


    case UPLOADING_NEW_VERSION_SUCCEEDED: {
      const { assetId, response } = action.payload as UploadNewVersionResponse;
      let tags = [];

      tags = _.get(response, 'tags', []);

      const filteredUploads = _.omitBy(state.upload, (item) => {
        return item.id !== assetId;
      });

      return {
        ...state,
        item: {
          ...response,
          tags: tags,
        },
        uploadVersion: initialVersionUploadState,
        upload: filteredUploads
      };
    }

    case UPLOADING_NEW_VERSION_FAILED: {
      const { error } = action.payload as UploadNewVersionErrorResponse;

      const errorCode = error?.errors?.[0]?.code;

      return {
        ...state,
        uploadVersion: {
          ...state.uploadVersion,
          uploading: false,
          uploaded: false,
          source: null,
          error: error,
        },
        storageLimit : {
          ...state.storageLimit,
          isLimitReached: errorCode === ErrorCodes.STORAGE_LIMIT_REACHED
        }
      };
    }

    case CANCEL_NEW_VERSION_UPLOAD: {
      return {
        ...state,
        uploadVersion: initialVersionUploadState
      }
    }

    case FETCH_ASSET_INSIGHTS: {
      return {
        ...state,
        insights: {
          loading: true,
          item: null,
          errors: null,
        },
      };
    }

    case FETCHING_ASSET_INSIGHTS_SUCCEEDED: {
      const data = action.payload;
      return {
        ...state,
        insights: {
          loading: false,
          item: data,
          errors: null,
        },
      };
    }

    case FETCHING_ASSET_INSIGHTS_FAILED: {
      const error = action.payload;
      return {
        ...state,
        insights: {
          loading: false,
          item: null,
          errors: error,
        },
      };
    }

    case WS_ASSET_MERGE_STATUS:
      return Object.assign({}, state, {
        ...state,
        merge: {
          ...state.merge,
          status: _.get(action, "payload.status", ""),
        },
      });

    case WS_ASSET_PROCESSED: {
      const asset = action.payload as Asset;
      const processedAssetId = asset.id;
      const id = _.get(state, 'item.id') || null;
      const assetProcessingStatus = asset.status;
      const merged = assetProcessingStatus === "OK" ? true : false;

      let assetItem = _.get(state, 'item');
      if (assetItem && processedAssetId == id) {
        const canEdit = _.get(state, 'item.canEdit');
        assetItem = {
          ...assetItem,
          ...action.payload as Asset,
          canEdit: canEdit
        }
      }

      let mergeState = _.get(state, 'merge');
      if (mergeState) {
        mergeState = {
          ...mergeState,
          status: assetProcessingStatus,
          merged: merged
        }
      }

      const uploads = { ...state.upload };
      _.keys(state.upload).forEach(key => {
        const uploadState = state.upload[key];
        if (uploadState.created && uploadState.item!.id === processedAssetId) {
          uploads[key] = {
            ...uploadState,
            item: asset
          }
        }
      });

      const links = { ...state.linkAsset };
      _.keys(state.linkAsset).forEach(key => {
        const linkState = state.linkAsset[key];
        if (linkState.created && linkState.item!.id === processedAssetId) {
          links[key] = {
            ...linkState,
            item: asset
          }
        }
      });

      return Object.assign({}, state, {
        ...state,
        item: assetItem,
        merge: mergeState,
        processedAsset: processedAssetId,
        upload: uploads,
        linkAsset: links
      });
    }
    case CLONE_ASSET_REQUEST: {
      return {
        ...state,
        clone: {
          cloning: true,
          cloned: false,
          item: null,
          error: null,
        },
        storageLimit : {
          ...state.storageLimit,
          isLimitReached: false
        }
      };
    }

    case CLONING_ASSET_SUCCEDDED: {
      return {
        ...state,
        clone: {
          cloning: false,
          cloned: true,
          item: action.payload as Asset,
          error: null,
        },
      };
    }

    case CLONING_ASSET_FAILED: {
      const { errors } = action.payload as CloningAssetErrorResponse

      const errorCode = errors?.errors?.[0]?.code;

      return {
        ...state,
        clone: {
          cloning: false,
          cloned: false,
          item: null,
          error: errors
        },
        storageLimit : {
          ...state.storageLimit,
          isLimitReached: errorCode === ErrorCodes.STORAGE_LIMIT_REACHED
        }
      };
    }

    case INVALIDATE_ASSET_CLONE: {
      return {
        ...state,
        clone: initialcloneState
      }
    }

    case SELECT_ASSET_PAGE: {
      const page = action.payload as IPage;
      const prevState = _.get(state, "selectedPages", []);
      return {
        ...state,
        selectedPages: [...prevState, page],
      };
    }

    case REMOVE_ASSET_PAGE: {
      const page = action.payload as IPage;
      const prevState = _.get(state, "selectedPages", []);
      return {
        ...state,
        selectedPages: _.filter(
          prevState,
          (item) =>
            _.get(item, "background.id") !== _.get(page, "background.id"),
        ),
      };
    }

    case REARRANGE_ASSET_PAGES: {
      const pages = action.payload as IPage[];
      return {
        ...state,
        selectedPages: pages,
      };
    }

    case INVALIDATE_SELECTED_ASSET_PAGES: {
      return {
        ...state,
        selectedPages: [],
      };
    }

    case CREATING_ASSET_FROM_HUB:
    case MODIFY_PAGES_IN_ASSET: {
      return {
        ...state,
        createAsset: {
          loading: true,
          succeeded: false,
          error: null,
          item: null,
        },
        merge: {
          ...state.merge,
          merging: true,
        },
        preparing: true,
      };
    }

    case CREATING_ASSET_FROM_HUB_SUCCEEDED:
    case MODIFYING_PAGES_IN_ASSET_SUCCEEDED: {
      const response = action.payload as Asset;
      return {
        ...state,
        createAsset: {
          loading: false,
          succeeded: true,
          error: null,
          item: response,
        },
        merge: {
          ...state.merge,
          merging: false,
          merged: true,
          initiated: true,
        },
        preparing: true,
      };
    }

    case CREATING_ASSET_FROM_HUB_FAILED:
    case MODIFYING_PAGES_IN_ASSET_FAILED: {
      const { error } = action.payload as any;
      return {
        ...state,
        createAsset: {
          loading: false,
          succeeded: false,
          error: error,
          item: null,
        },
        merge: {
          ...state.merge,
          merged: false,
          merging: false,
          error: error,
        },
        preparing: false,
      };
    }
    case INVALIDATE_ASSET_UPDATE: {
      const { id } = action.payload as InvalidateAssetUpdate;
      return {
        ...state,
        update: {
          ...state.update,
          [id]: {
            ...state.update[id],
            updated: false,
            updating: false,
          },
        },
      };
    }
    case TRIGGER_ASSET_PROCESSING_REQUEST: {
      return {
        ...state,
        process: {
          ...state.process,
          processing: true,
        },
      };
    }

    case TRIGGER_ASSET_PROCESSING_SUCCEEDED: {
      const { response } = action.payload as TriggerAssetProcessingResponse;
      return {
        ...state,
        process: {
          ...state.process,
          processing: false,
          processingCreatedDate: response.processingCreatedDate || null,
        },
        item: {
          ...state.item,
          processingCreatedDate: response.processingCreatedDate || null,
        },
      };
    }

    case TRIGGER_ASSET_PROCESSING_FAILED: {
      const { error } = action.payload as TriggerAssetProcessingErrorResponse;
      return {
        ...state,
        process: {
          ...state.process,
          processing: false,
          error: error,
        },
      };
    }

    case FETCHING_PREVIEW_HTML_TEMPLATE: {
      return {
        ...state,
        preview: {
          ...state.preview,
          loading: true,
        },
      };
    }

    case FETCHING_PREVIEW_HTML_TEMPLATE_SUCCEDDED: {
      return {
        ...state,
        preview: {
          ...state.preview,
          loading: false,
          htmlPreview: action.payload as string,
        },
      };
    }

    case FETCHING_PREVIEW_HTML_TEMPLATE_FAILED: {
      return {
        ...state,
        preview: {
          ...state.preview,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_RECOMMENDED_ASSETS:
      return {
        ...state,
        recommended: {
          loading: true,
          items: [],
          error: null,
        },
      };

    case FETCHING_RECOMMENDED_ASSETS_SUCCEDDED: {
      const { response } = action.payload as FetchRecommendedAssetsResponse;
      return {
        ...state,
        recommended: {
          loading: false,
          items: response,
          error: null,
        },
      };
    }

    case INVALIDATE_ASSET_RECOMMENDATIONS: {
      return {
        ...state,
        recommended: {
          loading: false,
          items: [],
          error: null,
        }
      }
    }

    case FETCHING_RECOMMENDED_ASSETS_FAILED:
      return {
        ...state,
        recommended: {
          loading: false,
          items: [],
          error: action.payload,
        },
      };

    //Upload Asset from file
    case UPLOAD_FILE_REQUEST: {
      const { file } = action.payload as UploadAssetRequest;
      return {
        ...state,
        upload: {
          ...state.upload,
          [file.id]: {
            ...initialUploadState,
            id: file.id,
            uploading: true,
            uploaded: false,
            item: {
              id: file.id,
              entityType: 'asset-upload',
              name: file.name,
              size: file.size,
              type: file.type,
              progress: 0,
              processing: false,
              optimizing: false
            },
            source: null,
            error: null
          }
        }
      }
    }

    case UPLOADING_FILE_PROGRESS: {
      const { id, progress } = action.payload as UploadAssetProgressRequest;

      const uploadState = state.upload[id];
      if (!uploadState) {
        return state;
      }

      return {
        ...state,
        upload: {
          ...state.upload,
          [id]: {
            ...uploadState,
            item: {
              ...(uploadState.item as AssetUpload),
              progress: progress
            }
          }
        }
      }
    }

    case UPLOADING_FILE_SUCCEDDED: {
      const { id } = action.payload as UploadAssetResponse;

      const uploadState = state.upload[id];
      if (!uploadState) {
        return state;
      }

      return {
        ...state,
        upload: {
          ...state.upload,
          [id]: {
            ...uploadState,
            uploading: false,
            uploaded: true,
          }
        }
      }
    }

    case UPLOADING_FILE_FAILED: {
      const { id, error } = action.payload as any;
      const uploadState = state.upload[id];
      if (!uploadState) {
        return state;
      }

      return {
        ...state,
        upload: {
          ...state.upload,
          [id]: {
            ...uploadState,
            uploading: false,
            uploaded: false,
            source: null,
            error: error
          }
        }
      }
    }

    case CREATE_ASSET_FROM_FILE_REQUEST: {
      const { id } = action.payload as any;
      const uploadState = state.upload[id];
      if (!uploadState) {
        return state;
      }

      return {
        ...state,
        upload: {
          ...state.upload,
          [id]: {
            ...uploadState,
            creating: true,
          }
        },
        storageLimit : {
          ...state.storageLimit,
          isLimitReached : false
        }
      }
    }

    case CREATING_ASSET_FROM_FILE_SUCCEDDED: {
      const { id, response } = action.payload as any;
      const uploadState = state.upload[id];
      if (!uploadState) {
        return state;
      }

      return {
        ...state,
        upload: {
          ...state.upload,
          [id]: {
            ...uploadState,
            creating: false,
            created: true,
            item: response,
          }
        }
      }
    }

    case CREATING_ASSET_FROM_FILE_FAILED :{
      const { id, error } = action.payload as any;
      const uploadState = state.upload[id];
      if (!uploadState) {
        return state;
      }

      const errorCode = error?.errors?.[0]?.code;

      return {
        ...state,
        upload: {
          ...state.upload,
          [id]: {
            ...uploadState,
            creating: false,
            created: false,
            error: error,
          }
        },

        storageLimit : {
          ...state.storageLimit,
          isLimitReached: errorCode === ErrorCodes.STORAGE_LIMIT_REACHED
        }
      }
    }

    case INVALIDATE_ASSET_UPLOAD: {
      const id = action.payload as string;

      return {
        ...state,
        upload: _.omit(state.upload, id)
      }
    }

    case CREATE_LINK_ASSET_REQUEST: {
      const { id, url } = action.payload as CreateLinkAssetRequest;

      return {
        ...state,
        linkAsset: {
          ...state.linkAsset,
          [id]: {
            id: id,
            creating: true,
            created: false,
            url: url,
            item: null
          }
        },
      };
    }

    case CREATING_LINK_ASSET_SUCCEEDED: {
      const { id, asset } = action.payload as CreateLinkAssetResponse;

      const linkState = state.linkAsset[id];
      if (!linkState) {
        return state;
      }

      return {
        ...state,
        linkAsset: {
          ...state.linkAsset,
          [id]: {
            ...linkState,
            creating: false,
            created: true,
            item: asset,
          }
        },
      };
    }

    case CREATING_LINK_ASSET_FAILED: {
      const { id, error } = action.payload as CreateLinkAssetErrorResponse;

      const linkState = state.linkAsset[id];
      if (!linkState) {
        return state;
      }

      return {
        ...state,
        linkAsset: {
          ...state.linkAsset,
          [id]: {
            ...linkState,
            creating: false,
            created: false,
            error: error
          }
        },
      };
    }

    case INVALIDATE_LINK_ASSET: {
      const id = action.payload;

      const linkState = _.omit(state.linkAsset, `['${id}']`);

      return {
        ...state,
        linkAsset: linkState
      };
    }

    case FETCH_ASSET_PROMPTS:
      return Object.assign({}, state, {
        ...state,
        seekPrompts: []
      });

    case FETCHING_ASSET_PROMPTS_SUCCEEDED:

      return Object.assign({}, state, {
        ...state,
        seekPrompts: action.payload
      });

    case FETCHING_ASSET_PROMPTS_FAILED:
      return Object.assign({}, state, {
        ...state,
        seekPrompts: []
      });

    case ADD_ASSETS_TO_COLLECTION_ON_SERVER:
    case ADD_ASSETS_TO_SECTION_ON_SERVER: {
      const { collection } = action.payload as AddAssetToCollectionRequest;

      return {
        ...state,
        collections: {
          ...state.collections,
          [collection]: {
            id: collection,
            adding: true,
            added: false,
            errors: null,
          },
        },
      };
    }

    case ADDING_ASSETS_TO_COLLECTION_ON_SERVER_SUCCEDDED: 
    case ADD_ASSETS_TO_SECTION_ON_SERVER_SUCCEDDED: {
      const { collection } = action.payload as AddAssetToCollectionResponse;

      const collectionState = state.collections[collection];
      if (!collectionState) {
        return state;
      }

      return {
        ...state,
        collections: {
          ...state.collections,
          [collection]: {
            id: collection,
            adding: false,
            added: true,
            errors: null,
          },
        },
      };
    }

    case ADDING_ASSETS_TO_COLLECTION_ON_SERVER_FAILED: 
    case ADD_ASSETS_TO_SECTION_ON_SERVER_FAILED: {
      const { collection, error } = action.payload as AddAssetToCollectionErrorResponse;

      const collectionState = state.collections[collection];
      if (!collectionState) {
        return state;
      }

      return {
        ...state,
        collections: {
          ...state.collections,
          [collection]: {
            id: collection,
            adding: false,
            added: false,
            errors: error,
          },
        },
      };
    }

    case INVALIDATE_ADD_ASSET_COLLECTIONS: {
      return {
        ...state,
        collections: {},
      };
    }

    case FETCHING_ASSET_STORAGE_LIMIT:{
      return {
        ...state,
        storageLimit:{
          ...state.storageLimit,
          fetching: true,
        }
      }
    }

    case FETCHING_ASSET_STORAGE_LIMIT_SUCCEEDED:{
      const  response  = action.payload as FetchAssetStorageLimitResponse;

      return {
        ...state,
        storageLimit: {
          fetching: false,
          error: null,
          paperfliteAssets: { assetStorageUsed: _.get(response, 'assetStorageUsed', 0), assetStorageLimit: _.get(response, 'assetStorageLimit', 0)},
          contentSource: { datasourceFilesUsed: _.get(response, 'datasourceFilesUsed', 0), datasourceFilesLimit: _.get(response, 'datasourceFilesLimit', 0)}
        }
      }
    }

    case FETCHING_ASSET_STORAGE_LIMIT_FAILED : {
      const error = action.payload as FetchAssetStorageLimitFailed

      return {
        ...state,
        storageLimit:{
          fetching: false,
          result: _.get(state,"storageLimit.result", []),
          error: error.error,
        }
      }
    }

    case FETCHING_CONTENT_RECOMMENDATIONS_REQUEST:
      return {
        ...state,
        recommendedAssets: {
          ...state.recommendedAssets,
          loading: true,
          error: null,
          fetched: false
        }
      };


    case FETCHING_CONTENT_RECOMMENDATIONS_SUCCEDDED: {
      const response = action.payload as Asset[]

      const items = _.slice(response, 0, 9);

      return {
        ...state,
        recommendedAssets: {
          loading: false,
          items: items,
          error: null,
          fetched : true
        }
      }
    }

    case FETCHING_CONTENT_RECOMMENDATIONS_FAILED: {
      return {
        ...state,
        recommendedAssets: {
          ...state.recommendedAssets,
          loading: false,
          error: action.payload,
          fetched:false
        }
      }
    }

    case ADD_ASSET_TO_CONTENT_SIMILARITY_QUEUE: {

    const response = action.payload as any;

    const id = response.asset.id;

    return {
      ...state,
      similarity: {
        ...state.similarity,
        [id]: {
          processing: false,
          processed: false,
          item: response.asset,
          initialise: response.initialise
          }
        }
      }
    }

    case TOGGLE_ASSET_STATUS_IN_CONTENT_SIMILARITY_QUEUE: {

      const response = action.payload as any;
      const id = _.get(response, "asset.id");

      if (!id) {
        return state;
      }

      return {
        ...state,
        similarity: {
          ...state.similarity,
          [id]: {
            processing: false,
            processed: false,
            item: response.asset,
            initialise: response.initialise
          }
        }
      }
    }

    case FETCH_DUPLICATE_ASSET: {
      const response = action.payload as any;
      const id = response.asset;

      return {
        ...state,
        similarity: {
          ...state.similarity,
          [id]: {
            ...state.similarity[id],
            processing: true,
            processed: false,
            similarAsset: null
          }
        }
      }
    }

    case FETCHING_DUPLICATE_ASSET_SUCCEDDED: {
      const response = action.payload as any;
      var id = response.asset.asset.id;

      if (_.size(_.get(response, "asset.similarAssets")) > 0) {
        return {
          ...state,
          similarity: {
            ...state.similarity,
            [id]: {
              ...state.similarity[id],
              processing: false,
              processed: true,
              similarAsset: response.asset.similarAssets[0]
            }
          }
        }
      }

      return state;
    }

    case INVALIDATE_SIMILAR_ASSET: {
      
      return {
        ...state,
        similarity: {
          processing: false,
          processed: false,
          item: null,
          initialise: false,
          similarAsset: null
        }
      }
    }

    case FETCH_TABLE_OF_CONTENTS: {
      return {
        ...state,
        tableOfContents: {
          ...state.tableOfContents,
          loading: true,
          sections: [],
          succeeded: false,
          error: null,
        },
      };
    }

    case FETCHING_TABLE_OF_CONTENTS_SUCCEEDED: {
      const response  = action.payload as FetchAssetTableOfContentsResponse;
      return {
        ...state,
        tableOfContents: {
          ...state.tableOfContents,
          loading: false,
          sections: response.sections,
          version: response.version,
          modifiedDate: response.modifiedDate,
          id: response.id,
          succeeded: true,
          error: null,
        },
      };
    }

    case FETCHING_TABLE_OF_CONTENTS_FAILED: {
      const { error } = action.payload as FetchAssetTableOfContentsErrorResponse;
      return {
        ...state,
        tableOfContents: {
          ...state.tableOfContents,
          loading: false,
          succeeded: false,
          error: error,
        },
      };
    }

    case UPDATE_TABLE_OF_CONTENTS: {

      return {
        ...state,
        tableOfContents: {
          ...state.tableOfContents,
          update: {
            loading: true,
            succeeded: false,
            error: null,
          }
        },
      };
    }
    case UPDATING_TABLE_OF_CONTENTS_SUCCEEDED: {
      const response  = action.payload as FetchAssetTableOfContentsResponse;
      return {
        ...state,
        tableOfContents: {
          ...state.tableOfContents,
          sections: response.sections,
          version: response.version,
          modifiedDate: response.modifiedDate,
          update: {
            loading: false,
            succeeded: true,
            error: null,
          }
        },
      };
    }
    case UPDATING_TABLE_OF_CONTENTS_FAILED: {
      const { error } = action.payload as updateTableOfContentsErrorResponse;
      return {
        ...state,
        tableOfContents: {
          ...state.tableOfContents,
          update: {
            loading: false,
            succeeded: false,
            error: error,
          }

        },
      };
    }

    case INVALIDATE_UPDATE_TABLE_OF_CONTENTS:{
      return {
        ...state,
        tableOfContents: {
          ...state.tableOfContents,
          update: {
            loading: false,
            succeeded: false,
            error: null,
          }
        },
      };
    }

    case DELETE_TABLE_OF_CONTENTS:
      return {
        ...state,
        tableOfContents: {
          ...state.tableOfContents,
          delete:{
            loading: true,
            succeeded: false,
            error: null,
          }
        },
      };

    case DELETING_TABLE_OF_CONTENTS_SUCCEEDED: {
      return {
        ...state,
        tableOfContents: {
          ...state.tableOfContents,
          delete: {
            loading: false,
            succeeded: true,
            error: null,
          }
        }
      }
    }

    case DELETING_TABLE_OF_CONTENTS_FAILED: {
      const { error } = action.payload as any;
      return {
        ...state,
        tableOfContents: {
          ...state.tableOfContents,
          delete: {
            loading: false,
            succeeded: false,
            error: error,
          }
        },
      };
    }

    case INVALIDATE_TABLE_OF_CONTENTS:{
      return {
        ...state,
        tableOfContents: initialTableOfContentsState
      }
    }

    case CAPTURED_ASSET_VIDEO_NEW_RANGE: {
      return {
        ...state,
        session: {
          ...state.session,
          ranges: [
            ..._.get(state, "session.ranges", []),
            action.payload
          ]
        }
      }
    }

    case UPDATED_ASSET_VIDEO_RANGE:
      const { id: rangeId, endRange, updatedDate } = action.payload as UpdateVideoRangeRequest;
      var ranges = [...state.session.ranges].map((range) => {
        if (range.id == rangeId) {
          return {
            ...range,
            end: Math.max(range.start, range.end, endRange),
            updatedDate: updatedDate,
            synced: false
          }
        }

        return range;
      });

      return {
        ...state,
        session: {
          ...state.session,
          ranges: ranges
        }
      }

    case REMOVED_ASSET_VIDEO_RANGE:
      var ranges = [...state.session.ranges].filter((range) => {
        return range.id != _.get(action, "payload.id","");
      });

      return {
        ...state,
        session: {
          ...state.session,
          ranges: ranges
        }
      }


    case SYNCING_ASSET_VIEW_RANGE_REQUEST:{
      const { id } = action.payload as SyncAssetVideoRangeRequest;
      var ranges = [...state.session.ranges].map((range) => {
        if (range.id == id) {
          return {
            ...range,
            syncing: true
          }
        }

        return range;
      });
      return Object.assign({}, state, {
        ...state,
        session: {
          ...state.session,
          ranges: ranges
        }
      })
    }

    case SYNCING_ASSET_VIEW_RANGE_SUCCEDDED:{
      const { id, range: response } = action.payload as SyncAssetVideoRangeResponse;

      var ranges = [...state.session.ranges].map((range) => {
        if (range.id == id) {
          return {
            ...range,
            syncing: false,
            synced: true,
            external_id: response.rangeId,
            syncedDate: new Date()
          }
        }

        return range;
      });

      return {
        ...state,
        session: {
          ...state.session,
          ranges: ranges
        }
      }
    }
    case SYNCING_ASSET_VIEW_RANGE_FAILED: {

      const { id } = action.payload as SyncAssetVideoRangeErrorResponse;
      var ranges = [...state.session.ranges].map((range) => {
        if (range.id == id) {
          return {
            ...range,
            syncing: false
          }
        }

        return range;
      });

      return {
        ...state,
        session: {
          ...state.session,
          ranges: ranges
        }
      }

    }

    case INVALIDATE_ASSET: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}